// app/javascript/controllers/reactivate_button_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submit"];

  reEnableButton(event) {
    // Allow some time for file download to trigger
    setTimeout(() => {
      this.submitTarget.disabled = false;
    }, 1000);
  }
}
